export let LoadingKey;
(function (LoadingKey) {
  LoadingKey["InitiateVerificationRequest"] = "InitiateVerificationRequest";
  LoadingKey["CompleteVerificationRequest"] = "CompleteVerificationRequest";
  LoadingKey["InitiateVerificationRequestExpiredRefresh"] = "InitiateVerificationRequestExpiredRefresh";
  LoadingKey["SignupRequest"] = "SignupRequest";
  LoadingKey["StandardLoading"] = "StandardLoading";
  LoadingKey["BlankScreenLoading"] = "BlankScreenLoading";
  LoadingKey["LoginAfterSignup"] = "LoginAfterSignup";
  LoadingKey["PartnerExistingAccount"] = "PartnerExistingAccount";
  LoadingKey["PostSignupLoading"] = "PostSignupLoading";
  LoadingKey["COAC0002PortalCreated"] = "COAC0002PortalCreated";
})(LoadingKey || (LoadingKey = {}));